import Modal from 'react-bootstrap/Modal';

export interface GeoPolygonImageModalProps {
  showImageModal: boolean;
  setShowImageModal: React.Dispatch<React.SetStateAction<boolean>>;
  geoPolygonImage: string;
};

// modal component for geoploygon map
export default function GeoPolygonImageModal(
  {
    showImageModal,
    setShowImageModal,
    geoPolygonImage,
  }: GeoPolygonImageModalProps
) {

  return (
    <>
      <Modal
        show={showImageModal}
        animation={true}
        size="lg"
        onHide={() => {
          setShowImageModal(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Selected geopolygon in the map</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={geoPolygonImage}
              alt="polygon"
              style={{ width: "100%" }}
            />
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
